import {HTTP, HTTPAUTH} from '../../utils/http-base';
import store from 'store';
import router from '@/router';
const buildData = require('../buildData/build');


// initial state
const state = {
  maContent : buildData,
}

// getters
const getters = {
 getBuildData : function(state){
    return state.maContent;
  },
}


export default {
  state,
  getters,
  
}


// WEBPACK FOOTER //
// ./src/store/modules/build.js